import { get } from 'lodash';
import moment from 'moment-timezone';
import { createSelector } from 'reselect';
import { TIMELINE_DIMENSION } from '@components/session-timeline/utils/constants';
import { selectedCustomerIdSelector } from '../../common/selectors';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);
export default selector;

export const storedDataKeySelector = createSelector(
  selectedCustomerIdSelector,
  customerId => {
    const localStorageKey = `${SCOPE}-${customerId}`;

    return localStorageKey;
  },
);

export const isFetchingSelector = createSelector(selector, store => {
  const data = get(store, ['isFetching'], true);
  return data;
});

export const timelineSummaryDataSelector = createSelector(selector, store => {
  const data = get(store, ['response', 'summaryData'], {});
  return data;
});

export const timelineDataSelector = createSelector(selector, store => (
  get(store, ['response', 'timelineData'], {}) || {}
));

export const timelinePIIDataSelector = createSelector(selector, store => {
  const data = get(store, ['response', 'piiData'], {});
  return data;
});

export const timelineDataDatePointsSelector = createSelector(timelineDataSelector, timelineData => {
  const dates: number[] = [];
  Object.values(timelineData).forEach(data => (data as any).forEach((d) => {
    const { timeMs, startTimeMs, endTimeMs } = d;
    if (timeMs) {
      dates.push(timeMs);
    }
    if (startTimeMs) {
      dates.push(startTimeMs);
    }
    if (endTimeMs) {
      dates.push(endTimeMs);
    }
  }));
  return [...new Set(dates)].sort();
});

export const actualTimelineIntervalSelector = createSelector(selector, data => (
  get(data, ['response', 'actualTimelineInterval'], null)
));

export const requestIntervalSelector = createSelector(actualTimelineIntervalSelector, interval => {
  const [startTime, endTime] = (interval || '0/0').split('/');

  return [moment(startTime).valueOf(), moment(endTime).valueOf()];
});

export const sessionStartEndSelector = createSelector(
  selector,
  requestIntervalSelector,
  (store, requestInterval) => {
    const summary = get(store, ['response', 'summaryData'], {});
    const start = get(summary, ['SessionStartTimestampMs'], requestInterval[0]);
    const end = get(summary, ['SessionEndTimestampMs'], requestInterval[1]);

    return [moment(start).valueOf(), moment(end).valueOf()];
  });

export const sessionIDSelector = createSelector(
  timelineSummaryDataSelector,
  (data) => get(data, ['SessionId'], null),
);

export const viewerIdSelector = createSelector(
  timelineSummaryDataSelector,
  timelinePIIDataSelector,
  (summaryData, piiData) => {
    const vid = get(summaryData, ['ViewerId'], null);

    if (vid) {
      return vid;
    } else {
      const piiVID = get(piiData, ['viewerId'], null);
      return piiVID;
    }
  });

export const eventNamesSelector = createSelector(
  timelineDataSelector,
  isFetchingSelector,
  (data, isFetchingSelector) => {
    if (isFetchingSelector) {
      return [] as string[];
    }
    const sessionEvent = get(data, [TIMELINE_DIMENSION.SessionEvent], []);

    return Array.from(new Set(
      sessionEvent.map(({ value }) => {
        // Error
        if (typeof value === 'object') {
          if (value.errorMessage) {
            return value.type || '';
          } else return '';
        } else if (typeof value === 'string') {
          return value.replace(/\s/g, '');
        }
      }),
    )) as string[];
  },
);

export const stateNamesSelector = createSelector(
  timelineDataSelector,
  isFetchingSelector,
  (data, isFetchingSelector) => {
    if (isFetchingSelector) {
      return [] as string[];
    }
    const sessionEvent = get(data, [TIMELINE_DIMENSION.SessionState], []);

    return Array.from(new Set(
      sessionEvent.map(({ value }) => typeof value === 'object' ? 'Other' : value.replace(/\s/g, '')),
    )) as string[];
  },
);
